import React, { useState } from 'react';

import { PhoneCallDetailDTO, Company, PointmanCustomerDetailDTO } from '_lib/api/apiTypes.shim';
import { WarningAlert } from '_lib/components/Alert/Alert';
import { Divider } from '_lib/components/Divider/Divider';
import { Stack } from '_lib/components/Stack/Stack';
import { Tab } from '_lib/components/Tab/Tab';
import { TabPanel } from '_lib/components/TabPanel/TabPanel';

import { Tabs } from '_lib/components/Tabs/Tabs';

import { Typography } from '_lib/components/Typography/Typography';

import { CustomerPhoneCallHistory } from '../../CustomerPhoneCallHistory/CustomerPhoneCallHistory';
import { HeaderTextBlock } from '../../HeaderTextBlock/HeaderTextBlock';

export const PhoneCallTabs = (props: {
  phoneCallDetailData: PhoneCallDetailDTO;
  companyData: Company;
  pointmanOrSwapiCustomer?: PointmanCustomerDetailDTO;
}) => {
  const { phoneCallDetailData, companyData, pointmanOrSwapiCustomer } = props;

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <Tabs value={tabIndex} onChange={(_event, newValue: number) => setTabIndex(newValue)}>
        <Tab key={0} label='NOTES' />
        <Tab key={1} label='CALL HISTORY' />
      </Tabs>
      <Divider />
      <TabPanel currentIndex={tabIndex} index={0} sx={{ overflow: 'auto' }}>
        <Stack useFlexGap spacing={2} sx={{ paddingX: 3, paddingY: 2, width: '100%' }}>
          <HeaderTextBlock headerText='Call Notes' text={phoneCallDetailData.notes} />
          <HeaderTextBlock headerText='Internal Notes' text={phoneCallDetailData.internalNotes} />
        </Stack>
      </TabPanel>
      <TabPanel currentIndex={tabIndex} index={1} sx={{ overflow: 'auto' }}>
        {(!!phoneCallDetailData.providerData?.customer || !!pointmanOrSwapiCustomer) && (
          <CustomerPhoneCallHistory
            company={companyData}
            providerCustomerId={phoneCallDetailData.providerData?.customer?.providerId}
            customerId={pointmanOrSwapiCustomer?.id}
          />
        )}
        {!phoneCallDetailData.providerData?.customer && !pointmanOrSwapiCustomer && (
          <WarningAlert sx={{ justifyContent: 'center', padding: 3, height: 'fit-content', width: '100%' }}>
            <Typography text='No Customer for this Call' />
          </WarningAlert>
        )}
      </TabPanel>
    </>
  );
};
